// video embed 2.4
// starts loading a video iframe
// when you click the play button
// or choose to do openVideoEmbeds(holderEl); in page.js
// works with youtube and vimeo
// also copy _video-embed-X.scss
// copy video-embed  html element for correct usage
// can use fader (fader--loader fader--lazy) on .video-embed
// changelog
// 2.1 add option to not open all video embeds with preview image
// 2.2 closes all other videos when opening a video
// 2.3 close all video embeds option
// 2.4 add new vimeo iframe code
// 2.5 remove elFromEvent

// imports --------------------------------------------------------------------
import * as Cookies from './0-cookies-v3.8.js';

// local variables ------------------------------------------------------------
let videoEmbedHolderEl;

export const initVideoEmbed = () => {
  // click listener --------------------------------
  document.body.addEventListener('click', event => {
    // video embed play
    let el = event.target.closest('.video-embed__play');
    if (el) {
      closeAllVideoEmbeds();
      openVideoEmbed(el.closest('.video-embed'));
    }
  });
};

export const openVideoEmbed = (videoEl, autoplay = false) => {
  // console.log('openVideoEmbed', { videoEl }, { autoplay });
  if (!videoEl) return;

  // if cookiesAcceptIframes is not set (no cookie popup) or iframes are accepted by cookies
  // console.log('cookiesAcceptIframes', Cookies.cookiesAcceptIframes);
  if (typeof Cookies === 'undefined' || ('cookiesAcceptIframes' in Cookies && Cookies.cookiesAcceptIframes)) {
    // show video's
    const type = videoEl.getAttribute('data-type');
    const id = videoEl.getAttribute('data-id');
    const foldout = videoEl.closest('.fold-out');

    // console.log({type, id, foldout});

    if (!type || !id || (foldout && !foldout.classList.contains('fold-out--opened'))) return;

    videoEl.classList.add('video-embed--show-iframe');

    let iframeHtml = '';
    if (type === 'youtube') {
      iframeHtml += `<iframe src="//www.youtube.com/embed/${id}${autoplay ? '?autoplay=1&mute=1' : ''}"></iframe>`;
    } else if (type === 'vimeo') {
      iframeHtml += `<iframe src="//player.vimeo.com/video/${id}?title=0&byline=0&loop=true${autoplay ? '&autoplay=1&muted=1' : ''}" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    }

    videoEl.insertAdjacentHTML('afterbegin', iframeHtml);

    const blockedIframeEl = videoEl.querySelector('.blocked-iframe');
    if (blockedIframeEl) blockedIframeEl.classList.remove('blocked-iframe--visible');
  } else {
    // cookiesAcceptIframes is defined and false
    // did not accept iframes
    console.log('show blocked');
    closeVideoEmbed(videoEl);
    const blockedIframeEl = videoEl.querySelector('.blocked-iframe');
    if (blockedIframeEl) blockedIframeEl.classList.add('blocked-iframe--visible');
  }
};

const closeVideoEmbed = videoEl => {
  // console.log('closeVideoEmbed', { videoEl });
  if (!videoEl) return;

  videoEl.classList.remove('video-embed--show-iframe');

  const iframeEl = videoEl.querySelector('iframe');
  if (iframeEl) iframeEl.remove();
};

export const openVideoEmbeds = (holderEl, openWithPreview = true) => {
  // console.log('openVideoEmbeds', holderEl);
  if (!holderEl) return;

  videoEmbedHolderEl = holderEl; // save for possible use in other scripts

  // skips closed foldouts
  const videoEmbedEls = holderEl.querySelectorAll('.video-embed');
  videoEmbedEls.forEach(videoEmbedEl => {
    const imgEl = videoEmbedEl.querySelector('img');

    if (openWithPreview || !imgEl) openVideoEmbed(videoEmbedEl, false);
  });
};

const closeVideoEmbeds = holderEl => {
  // console.log('closeVideoEmbeds', holderEl);
  if (!holderEl) return;

  const videoEmbeds = holderEl.querySelectorAll('.video-embed');
  videoEmbeds.forEach(closeVideoEmbed);
};

const closeAllVideoEmbeds = () => {
  // close other video embeds
  const videoEmbedEls = document.querySelectorAll('.video-embed--show-iframe');
  videoEmbedEls.forEach(videoEmbedEl => {
    closeVideoEmbed(videoEmbedEl);
  });
};
